<template>
  <Search />
</template>

<script>
import Search from '@/components/Search';
export default {
  components: {
    Search
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  }
};
</script>

<style></style>
